import { Component, Input, OnInit } from '@angular/core';
import { BaseField } from '../../baseField';
declare let $: any;

@Component({
  selector: 'app-cvv',
  templateUrl: './cvv.component.html',
  styleUrls: ['./cvv.component.scss']
})
export class CvvComponent extends BaseField implements OnInit {
  @Input() cardType:string;
  maxlength:number = 3;
  constructor() {
    super()
  }

  ngOnInit() {
    /*--------------------
    CodePen Tile Preview
    --------------------*/
    setTimeout(function () {
      $('#card-ccv').focus().delay(1000).queue(function () {
        $(this).blur().dequeue();
      });
    }, 500);
  }

  handleLength():void{
    if (this.cardType == 'American Express') this.maxlength = 4
    else this.maxlength = 3;

    $('.credit-card-box').addClass('hover');
    var card_cvv = '';
    card_cvv += $('#card-cvv').val();
    $('.ccv div').html(card_cvv);
    $('.credit-card-box').removeClass('hover');
  }

}
